export default __webpack_public_path__ + "static/media/lobby_first_image.00d9db41.jpg";